var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-skeleton-loader__table-tfoot-start mb-4"},[_c('v-skeleton-loader',{staticClass:"box-shadow--mod white",attrs:{"type":"card-heading, list-item-three-line, image, divider,list-item-three-line,table-tfoot"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }